import { FunctionComponent, ReactNode, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import cx from 'classnames'
import url from 'libraries/front-end-core/core/url'
import BrokenRefDialog from 'components/BrokenRefDialog'
import { DOCUMENTS_CONTENT } from 'constants/controllers'
import selectIsLogged from 'redux/selectors/selectIsLogged'
import { setSignUpModalIsOpen } from 'redux/actions'

interface SmartFcDocumentReferenceLinkProps {
  children: ReactNode
  attribs: {
    class: string
    'data-rootid'?: string
    'data-documentid'?: string
    'data-areaoflaw'?: string
  }
}

const SmartFcDocumentReferenceLink: FunctionComponent<SmartFcDocumentReferenceLinkProps> = ({
  children,
  attribs
}) => {
  const dispatch = useDispatch()
  const isLogged = useSelector(selectIsLogged)
  const [brokenRefModalOpen, setBrokenRefModalOpen] = useState(false)

  const { 'data-rootid': sectionId, 'data-documentid': focusedId, 'data-areaoflaw': aol } = attribs

  const isBrokenRef = [sectionId, focusedId, aol].some(value => (value ?? '') === '')

  const handleOnClick = (): void => {
    if (isBrokenRef) {
      setBrokenRefModalOpen(true)
    } else if (!isLogged) {
      dispatch(setSignUpModalIsOpen(true))
    }
  }

  return (
    <>
      <a
        className={cx('fc-document-reference', { pointer: !isLogged || isBrokenRef })}
        href={isLogged && !isBrokenRef ? url(DOCUMENTS_CONTENT, { aol, sectionId, focusedId }) : undefined}
        onClick={handleOnClick}
      >
        {children}
      </a>
      <BrokenRefDialog open={brokenRefModalOpen} onClose={() => setBrokenRefModalOpen(false)} />
    </>
  )
}

export default SmartFcDocumentReferenceLink
